{
    window.addEventListener('DOMContentLoaded', () => {
        const ceList = document.getElementsByClassName('t3-frontend-editing__ce');

        for(let ce of ceList) {
            const col = ce.querySelector('[class*=col-]');

            if (col) {
                ce.classList.add(...col.classList);
                const frame = col.getElementsByClassName('frame').item(0);
                ce.insertAdjacentElement('beforeend', frame);
                ce.removeChild(col);
            }
        }
    });
}